import React from 'react';
import {Link} from 'react-router-dom';
import DemoPlaceholder from './DemoPlaceholder';
import section from '../../styles/components/sections.module.css';
import styles from '../../styles/components/HeroSection.module.css';

const HeroSection: React.FC = () => {
  return (
    <section className={`${section.section} ${styles.hero}`}>
      <div className={section.container}>
        <h1 className={styles.headline}>Test Your Math Skills.<br />Compete Globally.</h1>
        <p className={styles.tagline}>
          Fast-paced arithmetic challenges across multiple game modes and difficulty levels. Climb the leaderboards and prove you're the best.
        </p>
        <div className={styles.buttons}>
          <a
            href="https://apps.apple.com/app/id123456789"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.btnPrimary}
          >
            Download App
          </a>
          <Link to="/ranking" className={styles.btnSecondary}>View Rankings</Link>
        </div>
        <div className={styles.demoWrapper}>
          <DemoPlaceholder />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
